// Footer.js
import React from 'react';
import mern from './MERN-logo.png';

const Footer = () => {

    const dateOptions = {
        weekday: 'long',
        year: 'numeric',   
        month: 'short',    
        day: 'numeric'   
    };

    return (
        <footer>
            <div className="footer-items">
                <div className="footer-item">
                     <img className="mern" src={mern} alt="MongoDb, Express, React, Node"/>
                </div>
                <div className="footer-item">
                    {new Date().toLocaleDateString('en-US', dateOptions )}
                </div>
                <div className="footer-item">
                    <a href="mailto:milleronic@gmail.com">Developer Contact</a>
                </div>
            </div>
        </footer>
    );
};

export default Footer;